module.exports = __webpack_public_path__ + "img/night.bdb1bfbd.svg";